
import http from  './axios'

export const searchSick = param =>{return http.post("clinic-manager/case/getHisClinicalPathway",param).then(res=>res.data.data)};
//根据name查询疾病信息
export const searchProject = param =>{return http.post("clinic-manager/case/getHisHospitalProjectByName",param).then(res=>res.data.data)};
//根据name查询项目信息

export const searchInspection = param =>{return http.post("clinic-manager/case/getHisClinicalPathwayRelation",param).then(res=>res.data.data)};
//根据id查询检验项目
export const inspectionType = param =>{return http.post("clinic-manager/case/getHisHospitalType",param).then(res=>res.data.data)};
//查询医院项目类型

export const projectByType = param =>{return http.post("clinic-manager/case/getHisHospitalProjectByTypeId",param).then(res=>res.data.data)};
//查询医院项目根据类型id，查询项目

export const samplingDetail = param =>{return http.post("partner-sale/hosptal/samplingDetailed",param).then(res=>res.data.data)};
//采集要求

export const depmentlist = param =>{return http.post("clinic-manager/case/getHisDepartmentPathway",param).then(res=>res.data.data)};
//查询科室下的疾病

export const comProject = param =>{return http.post("clinic-manager/case/getCommonProject",param).then(res=>res.data.data)};
//查询科常用项目

//过敏

export const getSymptom = param =>{return http.post("clinic-manager/case/getBehaviorType",param).then(res=>res.data.data)};
//过敏表现
export const getAllerSo = param =>{return http.post("clinic-manager/case/getSourceType",param).then(res=>res.data.data)};
//过敏源
export const getLevel = param =>{return http.post("clinic-manager/case/getSourceDegree",param).then(res=>res.data.data)};
//过敏程度

export const isSingleItem = param =>{return http.post("/partner-sale/hosptal/getMeal",param).then(res=>res.data.data)};
//查询是否包含单品
export const projectItems = param =>{return http.post("partner-sale/hosptal/getProjectName",param).then(res=>res.data.data)};
//查询产品集合

export const saveCase = param =>{return http.post("clinic-manager/case/saveHisCase",param).then(res=>res.data.data)};
//保存病历

export const patientSource = param =>{return http.post("clinic-manager/registered/getHisPatientSource",param).then(res=>res.data.data)};
//患者来源

export const clinicalList = param =>{return http.post("clinic-manager/registered/getHisDiagnosis",param).then(res=>res.data.data)};
//待诊就诊列表

export const getHisDiagnosisById = param =>{return http.post("clinic-manager/registered/getHisDiagnosisById",param).then(res=>res.data.data)};
//获取待诊病历信息通过id

export const updCase = param =>{return http.post("clinic-manager/case/getHisCaseByRegisteredId",param).then(res=>res.data.data)};
//修改今日就诊病历信息

export const commonDisease = param =>{return http.post("clinic-manager/registered/getHisCommonDisease",param).then(res=>res.data.data)};
//右侧常用项目

export const commonSymptom = param =>{return http.post("clinic-manager/registered/getHisCommonSymptom",param).then(res=>res.data.data)};
//右侧常用症状

export const expansionPro = param =>{return http.post("clinic-manager/registered/getHisProjectExtension",param).then(res=>res.data)};
//右侧推广项目

export const historyList = param =>{return http.post("clinic-manager/case/getHisCaseByPhoneAndName",param).then(res=>res.data.data)};
//历史病历

export const patientByname = param =>{return http.post("clinic-manager/case/getHisCaseByName",param).then(res=>res.data.data)};
//根据姓名搜索患者信息

export const getPerformance = param =>{return http.post("clinic-manager/registered/getHisPerformance",param).then(res=>res.data.data)};
//主诉病情

export const getDiagnosiss = param =>{return http.post("clinic-manager/registered/getHisDiagnosiss",param).then(res=>res.data.data)};
//诊断

export const getProjectByName = param =>{return http.post("clinic-manager/case/getHisClinicalPathwayByName",param).then(res=>res.data.data)};
//根据项目名称查询疾病



// WEBPACK FOOTER //
// ./src/api/clinic.js